import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";

/**
 * A skeleton loader for the Hangars page
 * This displays placeholder elements while the real data is loading
 */
export const HangarsSkeleton: React.FC = () => {
  return (
    <Box sx={{ ml: 2, mr: 2, height: "100%" }}>
      <Stack direction="column" sx={{ height: "100%" }}>
        {/* Title skeleton */}
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ mt: 2, mb: 2 }}
        >
          <Skeleton variant="text" width={300} height={40} />
        </Stack>

        {/* Summary cards and multi-hangar button skeleton */}
        <Stack
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            sx={{ minWidth: 500 }}
          >
            {/* Total Hangars card */}
            <Card variant="outlined" sx={{ width: "100%" }}>
              <CardContent>
                <Typography variant="subtitle1">
                  <Skeleton width={120} />
                </Typography>
                <Typography variant="h5">
                  <Skeleton width={40} />
                </Typography>
              </CardContent>
            </Card>

            {/* Total Aircraft in Hangars card */}
            <Card variant="outlined" sx={{ width: "100%" }}>
              <CardContent>
                <Typography variant="subtitle1">
                  <Skeleton width={180} />
                </Typography>
                <Typography variant="h5">
                  <Skeleton width={40} />
                </Typography>
              </CardContent>
            </Card>
          </Stack>

          {/* Multi-hangar button placeholder */}
          <Stack
            direction="column"
            justifyContent="flex-end"
            alignItems="flex-end"
            sx={{ width: 200, height: "100%" }}
          >
            <Skeleton variant="rounded" width={180} height={40} />
          </Stack>
        </Stack>

        {/* DataGrid skeleton */}
        <Skeleton 
          variant="rectangular" 
          height="calc(100vh - 200px)" 
          width="100%" 
          sx={{ 
            minHeight: 400,
            animation: "pulse 1.5s ease-in-out 0.5s infinite"
          }}
        />

        {/* Skeleton rows to simulate data */}
        <Box sx={{ display: "none" }}>
          {[...Array(5)].map((_, index) => (
            <Stack 
              key={index}
              direction="row" 
              spacing={2} 
              sx={{ mt: 1 }}
            >
              <Skeleton variant="text" width={200} height={30} />
              <Skeleton variant="text" width={150} height={30} />
              <Skeleton variant="text" width={175} height={30} />
              <Skeleton variant="text" width={115} height={30} />
              <Skeleton variant="text" width={140} height={30} />
              <Skeleton variant="text" width={125} height={30} />
              <Skeleton variant="text" width={250} height={30} />
            </Stack>
          ))}
        </Box>
      </Stack>
    </Box>
  );
};
